import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  fetchAllUsers,
  addUser,
  deleteUser,
  updateUser,
  sortStudents,
  archiveStudent,
  restoreStudent,
  bulkArchiveStudent,
  bulkRestoreStudent,
  bulkDeleteStudent,
} from '../../redux/actions/student';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import Loader from '../../../../components/Loader';
import EnhancedTable from '../../components/Table';
import PageHeader from '../../components/PageHeader';
import DeleteDialog from 'components/DeleteDialog';
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import ArchiveIcon from '@material-ui/icons/Archive';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import RestoreFromTrash from '@material-ui/icons/RestoreFromTrash';

import StudentDialog from 'containers/SuperAdmin/components/StudentDialog';
import FilterBar from 'containers/SuperAdmin/components/FilterBar';
import { useHistory, useParams } from 'react-router-dom';
import { enqueueSnackbar } from 'redux/actions';
import RestoreStudentDialog from 'containers/SuperAdmin/components/RestoreStudentDialog';
import { fetchLicenses } from 'containers/SuperAdmin/redux/actions/license';
import { disabledSchoolFields } from 'containers/SuperAdmin/constants';
import { useQuery } from 'constants';

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
  },
}));

let initialUser = {
  firstName: '',
  lastName: '',
  username: '',
  password: '',
  grade: '',
  school: '',
  teacher: '',
};

export default function StudentsByGrade() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const { grade } = useParams();
  const isArchived = useQuery('isArchived');

  const [deleteId, setDeleteId] = useState(null);
  const [deleteIds, setDeleteIds] = useState([]);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  const [archiveId, setArchiveId] = useState(null);
  const [archiveIds, setArchiveIds] = useState([]);
  const [openArchiveDialog, setOpenArchiveDialog] = useState(false);

  const [restoreId, setRestoreId] = useState(null);
  const [restoreIds, setRestoreIds] = useState([]);
  const [openRestoreDialog, setOpenRestoreDialog] = useState(false);
  const [restoreUser, setRestoreUser] = useState(null);

  const [userData, setUserData] = useState(null);
  const [userDialog, setUserDialog] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [editUser, setEditUser] = useState(false);
  const [view, setView] = useState(isArchived ? 'archived' : 'normal');
  const [sort, setSort] = useState({ orderBy: 'fullName', orderDir: 'asc' });

  const [school, setSchool] = useState('');

  const { users, fetching } = useSelector(({ admin }) => admin.student);
  const { licenseData } = useSelector(({ admin }) => admin.license);

  const loadPage = (page, sortOptions = {}) => {
    let options = {
      ...sortOptions,
    };

    if (options.orderBy === 'fullName') {
      options.orderBy = 'name';
    }

    if (grade) {
      options.grade = grade;
    }

    if (school) {
      options.school = school;
    }

    if (view === 'archived') {
      options.isArchived = true;
    }
    dispatch(sortStudents(sortOptions.orderBy, sortOptions.orderDir, users?.docs));
    setSort(sortOptions);
  };

  const handleAction = () => {
    let options = {};
    if (grade) {
      options.grade = grade;
    }
    if (school) {
      options.school = school;
    }
    if (view === 'normal') {
      options.isArchived = true;
    }
    dispatch(fetchAllUsers(options));
    setView(view === 'normal' ? 'archived' : 'normal');
    if (isArchived && grade) {
      history.push(`/superadmin/grades/${grade}/students`);
    }
  };

  const handleSearch = (d) => {
    let options = { search: d };
    if (grade) {
      options.grade = grade;
    }
    if (school) {
      options.school = school;
    }
    if (view === 'archived') {
      options.isArchived = true;
    }
    dispatch(fetchAllUsers(options));
  };

  const handleSchool = (d) => {
    setSchool(d);
    let options = {};
    if (d) {
      options.school = d;
    }
    if (grade) {
      options.grade = grade;
    }
    if (view === 'archived') {
      options.isArchived = true;
    }
    dispatch(fetchAllUsers(options));
  };

  const headCells = [
    { id: 'checkbox', label: 'Select' },
    { id: 'fullName', label: 'Name' },
    { id: 'username', label: 'Username' },
    {
      id: `licenseType`,
      label: 'School',
    },
    {
      id: 'className',
      label: 'Class',
    },
    {
      id: 'teacherName',
      label: 'Teacher',
    },
    {
      id: 'actions',
      label: 'Actions',
      actions:
        view === 'normal'
          ? [
              {
                label: 'Edit',
                action: (r) => {
                  setEditUser(true);
                  let userEditData = {
                    ...r,
                    teacher: r.teacher ? r.teacher?._id : '',
                    grade: r.grade ? r.grade?._id : '',
                    school: r.school ? r.school?._id : '',
                  };
                  setUserData(userEditData);
                  setUserDialog(true);
                },
                icon: <EditIcon />,
                disabled: () => false,
              },
              {
                label: 'Archive',
                action: (r) => {
                  if (!r.school) {
                    dispatch(
                      enqueueSnackbar({
                        message:
                          'You are attempting to archive an Individual Student. You can perform this action only from Licenses Page.',
                        options: {
                          key: new Date().getTime() + Math.random(),
                          variant: 'error',
                        },
                      }),
                    );
                  } else {
                    setArchiveId(r._id);
                    setOpenArchiveDialog(true);
                  }
                },
                icon: <ArchiveIcon />,
                disabled: (r) => r?.isWixUser || false,
              },
            ]
          : [
              {
                label: 'Restore',
                action: (r) => {
                  if (!r.school) {
                    dispatch(
                      enqueueSnackbar({
                        message:
                          'You are attempting to restore an Individual Student. You can perform this action only from Licenses Page.',
                        options: {
                          key: new Date().getTime() + Math.random(),
                          variant: 'error',
                        },
                      }),
                    );
                  } else {
                    const license = licenseData?.find((x) => x.licensee === r.school?._id);
                    if (license?.isArchived && license?.status === 'Deactivated') {
                      dispatch(
                        enqueueSnackbar({
                          message:
                            'Student(s) cannot be restored because the License they belong to is inactive. Please reactivate their License first.',
                          options: {
                            key: new Date().getTime() + Math.random(),
                            variant: 'error',
                          },
                        }),
                      );
                    } else if (license && license.consumedStudentLicenses === license.studentLicenses) {
                      dispatch(
                        enqueueSnackbar({
                          message:
                            'The active Student Pool of this License is full. Please Archive active Students or allot space for additional Student Accounts within the License',
                          options: {
                            key: new Date().getTime() + Math.random(),
                            variant: 'error',
                          },
                        }),
                      );
                    } else if (license && license.consumedStudentLicenses + 1 > license.studentLicenses) {
                      dispatch(
                        enqueueSnackbar({
                          message:
                            'The active Student Pool of this License is full. Please archive 1 active student or allot space for 1 additional Student account within the License',
                          options: {
                            key: new Date().getTime() + Math.random(),
                            variant: 'error',
                          },
                        }),
                      );
                    } else {
                      setRestoreId(r._id);
                      setRestoreUser(r);
                      setOpenRestoreDialog(true);
                    }
                  }
                },
                icon: <RestoreFromTrash />,
                disabled: () => false,
              },
              {
                label: 'Permanently Delete',
                action: (r) => {
                  setDeleteId(r._id);
                  setOpenDeleteDialog(true);
                },
                icon: <DeleteForeverIcon />,
                disabled: (r) => r.isSuperAdmin,
              },
            ],
    },
  ];

  const onConfirmStudent = (data, emailTrigger) => {
    if (editUser) {
      setUpdating(true);
      const id = userData?._id;
      let update = {
        firstName: data?.firstName,
        lastName: data?.lastName,
        username: data?.username,
        email: data?.email,
        school: data?.school,
        status: data?.status,
        city: data?.city,
        state: data?.state,
        schoolName: data?.schoolName,
        country: data?.country,
        emailTrigger,
        teacher: data?.teacher,
        grade: data?.grade,
      };
      if (data.password !== '') {
        update.password = data.password;
      }
      dispatch(
        updateUser(id, update, () => {
          setUserData(initialUser);
          setUserDialog(false);
          setUpdating(false);
        }),
      );
    } else {
      dispatch(addUser(data));
      setUserData(initialUser);
      setUserDialog(false);
    }
  };

  useEffect(() => {
    if (!grade) return;
    dispatch(fetchAllUsers({ grade, isArchived }));
    dispatch(fetchLicenses());
    if (isArchived) {
      setView('archived');
    }
  }, [dispatch, grade, isArchived]);

  return (
    <div className={classes.root}>
      {fetching && <Loader fetching={fetching} />}
      <PageHeader
        title="Students"
        options={
          <>
            <IconButton
              onClick={() => {
                setEditUser(false);
                setUserData(initialUser);
                setUserDialog(true);
              }}
            >
              <AddIcon />
            </IconButton>
          </>
        }
        onClearFilter={() => {
          if (grade !== undefined && grade !== null) {
            if (view === 'archived') {
              history.push('/superadmin/grades?isArchived=true');
            } else {
              history.push('/superadmin/grades');
            }
          } else {
            history.push('/superadmin/grades');
          }
        }}
      />
      <FilterBar
        enableTopics={false}
        enableGlobal
        selectedPage="Students"
        onSearch={handleSearch}
        onAction={handleAction}
        toggle={view === 'archived'}
        enableSchool
        selectedSchool={school}
        onSchoolSelect={handleSchool}
      />
      {users && users.docs.length > 0 && (
        <Grid container direction="row" justifyContent="flex-start" spacing={2}>
          <Grid item sm={12} xs={12}>
            <EnhancedTable
              data={{
                ...users,
                docs: users.docs.filter((x) => (view === 'normal' ? !x.isArchived : x.isArchived)),
                totalDocs: users.docs.filter((x) => (view === 'normal' ? !x.isArchived : x.isArchived)).length,
              }}
              headCells={headCells}
              handlePage={loadPage}
              orderField={sort.orderBy}
              orderDirection={sort.orderDir}
              handleOrder={(d) => loadPage(1, d)}
              disablePagination={true}
              view={view}
              handleBulk={(data) => {
                const ids = data?.map((d) => d._id);
                setArchiveId(null);
                setRestoreId(null);
                if (view === 'normal') {
                  setArchiveIds(ids);
                  setOpenArchiveDialog(true);
                } else {
                  const restoreData = data[0];
                  if (!restoreData?.school) {
                    dispatch(
                      enqueueSnackbar({
                        message:
                          'You are attempting to restore an Individual Student. You can perform this action only from Licenses Page.',
                        options: {
                          key: new Date().getTime() + Math.random(),
                          variant: 'error',
                        },
                      }),
                    );
                    return;
                  }
                  const license = licenseData?.find((x) => x.licensee === restoreData?.school?._id);
                  if (license?.isArchived && license?.status === 'Deactivated') {
                    dispatch(
                      enqueueSnackbar({
                        message:
                          'Student(s) cannot be restored because the License they belong to is inactive. Please reactivate their License first.',
                        options: {
                          key: new Date().getTime() + Math.random(),
                          variant: 'error',
                        },
                      }),
                    );
                  } else if (license && license.consumedStudentLicenses === license.studentLicenses) {
                    dispatch(
                      enqueueSnackbar({
                        message:
                          'The active Student Pool of this License is full. Please Archive active Students or allot space for additional Student Accounts within the License',
                        options: {
                          key: new Date().getTime() + Math.random(),
                          variant: 'error',
                        },
                      }),
                    );
                  } else if (license && license.consumedStudentLicenses + ids?.length > license.studentLicenses) {
                    const additionalSpacesRequired =
                      ids?.length - (license.studentLicenses - license.consumedStudentLicenses);
                    dispatch(
                      enqueueSnackbar({
                        message: `You are attempting to unarchive ${ids?.length} student(s). Please archive ${additionalSpacesRequired} active student(s) or allot space for ${additionalSpacesRequired} additional Student account(s) within the License`,
                        options: {
                          key: new Date().getTime() + Math.random(),
                          variant: 'error',
                        },
                      }),
                    );
                  } else {
                    setRestoreIds(ids);
                    setRestoreUser(restoreData);
                    setOpenRestoreDialog(true);
                  }
                }
              }}
              handleBulkDelete={(data) => {
                const ids = data?.map((d) => d._id);
                setDeleteId(null);
                setDeleteIds(ids);
                setOpenDeleteDialog(true);
              }}
            />
          </Grid>
        </Grid>
      )}
      {userData && (
        <StudentDialog
          open={userDialog}
          edit={editUser}
          data={userData}
          disableDone={true}
          disabledFields={
            !editUser ? disabledSchoolFields : userData?.school || userData?.isGeneric ? disabledSchoolFields : []
          }
          suffix="to an Active Group License"
          handleClose={() => {
            setUserData(initialUser);
            setUserDialog(false);
          }}
          handleConfirm={onConfirmStudent}
          sending={updating}
        />
      )}
      <DeleteDialog
        open={openArchiveDialog}
        content={
          'Are you sure you want to archive student(s)? You can restore them at any time from the Archive Folder, as long as their License is Active.'
        }
        handleClose={() => {
          setOpenArchiveDialog(false);
          setArchiveId(null);
          setArchiveIds([]);
        }}
        handleConfirm={() => {
          if (archiveId && archiveIds?.length === 0) {
            dispatch(archiveStudent(archiveId));
            setArchiveId(null);
          } else {
            dispatch(bulkArchiveStudent(archiveIds));
            setArchiveIds([]);
          }
          setOpenArchiveDialog(false);
        }}
        confirmLabel={'Yes'}
        cancelLabel={'No'}
      />
      <DeleteDialog
        open={openDeleteDialog}
        content={
          'Warning! Are you sure you want to permanently delete this student(s) & all of their records? This action can’t be undone.'
        }
        handleClose={() => {
          setOpenDeleteDialog(false);
          setDeleteId(null);
          setDeleteIds([]);
        }}
        handleConfirm={() => {
          if (deleteId && deleteIds?.length === 0) {
            dispatch(deleteUser(deleteId));
            setDeleteId(null);
          } else {
            dispatch(bulkDeleteStudent(deleteIds));
            setDeleteIds([]);
          }
          setOpenDeleteDialog(false);
        }}
        confirmLabel={'Yes'}
        cancelLabel={'No'}
      />
      <RestoreStudentDialog
        open={openRestoreDialog}
        handleClose={() => {
          setOpenRestoreDialog(false);
          setRestoreId(null);
          setRestoreIds([]);
          setRestoreUser(null);
        }}
        handleConfirm={(data) => {
          if (restoreId && restoreIds.length === 0) {
            dispatch(restoreStudent(restoreId, data));
          } else {
            dispatch(bulkRestoreStudent(restoreIds, data?.grade, data?.teacher));
          }
          setOpenRestoreDialog(false);
          setRestoreId(null);
          setRestoreIds([]);
          setRestoreUser(null);
        }}
        school={restoreUser?.school?._id}
      />
    </div>
  );
}
